/**
 * The panel's entrance and exit motion, shared across the process boundary.
 *
 * The panel glass is a web animation in the overlay renderer; the blur behind
 * it is a CoreAnimation on a native NSView. The surface is only 95% opaque and
 * the blur spills 84px past the panel's inner edge, so both are on screen at
 * once — any disagreement in duration or curve reads as the panel's interior
 * lagging its own edge. One definition, both sides.
 *
 * A tween rather than the spring the panel used to run: a cubic bezier can't
 * track a critically-damped exponential closely (best fits leave ~5% of travel
 * mid-flight, which is exactly where the eye is), so rather than approximate
 * the spring on the native side, both sides run the same explicit curve.
 *
 * `SIDEPANEL_SPRING` still owns the gesture-driven motion (swipe-dismiss,
 * re-dock, snap-back), where velocity handoff matters and a tween would flatten
 * the follow-through.
 */

/** Fitted to the critically-damped 0.2s spring this replaced (ω ≈ 46.1 rad/s). */
export const SIDEPANEL_OPEN_DURATION_S = 0.2
export const SIDEPANEL_OPEN_EASE = [0.22, 0.18, 0, 1] as const

/** The exit is deliberately slower than the entrance — leaving is less urgent. */
export const SIDEPANEL_CLOSE_DURATION_S = 0.4
export const SIDEPANEL_CLOSE_EASE = [0.4, 0, 0.2, 1] as const

export type SidepanelEase = readonly [number, number, number, number]
